import { render, staticRenderFns } from "./gzhFieldColumnList.vue?vue&type=template&id=b147277e&scoped=true&"
import script from "./gzhFieldColumnList.vue?vue&type=script&lang=js&"
export * from "./gzhFieldColumnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b147277e",
  null
  
)

export default component.exports